module.exports = __webpack_public_path__ + "static/media/gallery-placeholder.446a5598.svg";